export const environment = {
  production: true,
  ga4MeasurementId: 'G-WBB6LVHX2H',
  ttsUrl: 'https://proxy-tts.meyler.it',
  ttsCredentials: {username: 'teom', password: 'tts-test'},
};
